import { Button } from '@/common/ui/button'
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@/common/ui/alert-dialog'
import { Trash2 } from 'lucide-react'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useQueryClient } from '@tanstack/react-query'
import useMutationDeleteAnnouncement from '@/modules/announcement/api/hooks/useMutationDeleteAnnouncement'
import { AnnouncementQueryKeys } from '@/modules/announcement/keys'

interface DeleteAnnouncementModalProps {
	id: string
}

export default function DeleteAnnouncementModal({
	id,
}: DeleteAnnouncementModalProps) {
	const queryClient = useQueryClient()
	const { mutate: deleteAnnouncement } = useMutationDeleteAnnouncement({
		onSuccess: () => {
			toast.success('ลบประกาศสำเร็จ')
			queryClient.invalidateQueries({
				queryKey: [AnnouncementQueryKeys.getAnnouncement],
				exact: false,
			})
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})

	const handleDelete = () => {
		deleteAnnouncement({ id })
	}

	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<Button variant="ghost" size="icon">
					<Trash2 className="h-4 w-4 text-destructive" />
				</Button>
			</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>ยืนยันการลบประกาศ</AlertDialogTitle>
					<AlertDialogDescription>
						คุณต้องการลบประกาศนี้ใช่หรือไม่?
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter className="gap-2">
					<AlertDialogCancel>ยกเลิก</AlertDialogCancel>
					<AlertDialogAction
						onClick={handleDelete}
						className="bg-destructive hover:bg-destructive/90"
					>
						ยืนยัน
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
